import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PageScrollHandler: React.FC = ({ children }) => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return <>{children}</>;
};

export default PageScrollHandler;
